import React from "react";
import PageTitle from "components/v1/PageTitle";
import CashDepositCard from "./CashDepositCard";
import { CashDepositContainer } from "./styles";

function CashDeposit({ cdDetail }) {
  return (
    <section>
      <PageTitle title="Cash Deposit Balance" />
      <CashDepositContainer>
        {Object.keys(cdDetail).map((cd) => (
          <CashDepositCard cashDeposit={cdDetail[cd]} key={cd} />
        ))}
      </CashDepositContainer>
    </section>
  );
}

export default CashDeposit;
